var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBCabinetWalletDomIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_9292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#D862EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1288 20L27.2488 14.5602C27.3624 14.4592 27.4425 14.3259 27.4787 14.1782C27.5148 14.0305 27.5052 13.8753 27.4511 13.7332C27.397 13.5911 27.301 13.4688 27.1758 13.3825C27.0506 13.2962 26.9021 13.25 26.75 13.25H24.5V9.5H23V14.75H24.7775L20 18.9965L15.2225 14.75H17V9.5H15.5V13.25H13.25C13.0979 13.25 12.9495 13.2962 12.8243 13.3825C12.6991 13.4688 12.603 13.5911 12.5489 13.7332C12.4948 13.8753 12.4852 14.0305 12.5214 14.1782C12.5575 14.3259 12.6377 14.4592 12.7513 14.5602L18.8713 20L12.7513 25.4398C12.6377 25.5408 12.5575 25.6741 12.5214 25.8218C12.4852 25.9695 12.4948 26.1247 12.5489 26.2668C12.603 26.4089 12.6991 26.5312 12.8243 26.6175C12.9495 26.7038 13.0979 26.75 13.25 26.75H15.5V30.5H17V25.25H15.2225L20 21.0035L24.7775 25.25H23V30.5H24.5V26.75H26.75C26.9021 26.75 27.0506 26.7038 27.1758 26.6175C27.301 26.5312 27.397 26.4089 27.4511 26.2668C27.5052 26.1247 27.5148 25.9695 27.4787 25.8218C27.4425 25.6741 27.3624 25.5408 27.2488 25.4398L21.1288 20Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_9292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCabinetWalletDomIcon);
export default __webpack_public_path__ + "static/media/b_cabinet_wallet_dom_icon.c0caab6aea985d555eba449086f6bc60.svg";
export { ForwardRef as ReactComponent };